import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9572527e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-manual-monitor" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title f-size-24 f-col-white08" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "descriptions-item point" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "主要超标污染物:", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "newest-parameter" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 最新水质参数： ", -1))
const _hoisted_10 = { class: "parameter" }
const _hoisted_11 = { class: "parameter-box" }
const _hoisted_12 = { class: "box-content" }
const _hoisted_13 = { class: "key" }
const _hoisted_14 = { class: "echart" }
const _hoisted_15 = { class: "header" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_19 = { class: "body" }

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
import Bus from '@/config/Bus'
import { Api, DmYzDatumLineQuery } from '@/api/publicApi'
import AutoMonitor from '../charts/AutoMonitor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogManualMonitor',
  props: {
  data: Object,
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const api = new Api()
const emit = __emit

const autoMonitor = ref()
const options = []
const selectFactor = ref({code:""})
const echartTime = ref('H')
const startTime = new Date()
const parameter = {
  title: '',
  data: [],
}
const select = async (val) => {
  switch (val) {
    case 'H':
      echartTime.value = 'H'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    case 'D':
      echartTime.value = 'D'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    default:
      selectFactor.value = val
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName, {
      //   standValues: val.standValues,
      //   unit: val.unit,
      // });
      break
  }
}
const getFontSize = (value: any) => {
  let className = ''
  let val = value
  if (!value) {
    return className
  }
  if (typeof value === 'number') {
    val = `${value}`
  }
  if (val.length < 6) {
    className = 'font-size48'
  } else if (val.length < 10) {
    className = 'font-size40'
  } else {
    className = 'font-size34'
  }
  return className
}
// 获取echart趋势数据
const getTrend = async () => {
  const data = []
  //   const data = await getMonitorDataListUsingGET({
  //     begin: this.formatDate(this.startTime, 'yyyy-MM-dd hh:mm:ss'),
  //     factor: this.selectFactor.factorCode,
  //     frequency: this.echartTime,
  //     mn: this.data.id,
  //   });
  const XData = []
  const YData = []
  for (let i = 0; i < data.length; i += 1) {
    XData.push(data[i].dataTime)
    YData.push(data[i].value)
  }

  let markLine
  const params: DmYzDatumLineQuery = {
    code: selectFactor.value.code,
    stlx: props.data.stlx,
    bzszlb: props.data.bzszlbdm,
  }
  await api.screen.getDmYzDatumLineUsingPost(params).then((res) => {
    if (res.code === 200) {
      markLine = res.data
    }
  })

  await autoMonitor.value.initChart(
    selectFactor.value.xaxis,
    selectFactor.value.trend,
    selectFactor.value.name,
    markLine
  )
}
const getYzCbBs = (array: any[]) => {
  let res = '无'
  if (array && array.length) {
    res = ''
    array.forEach((item, index) => {
      if (index + 1 < array.length) {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}），`
      } else {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}）`
      }
    })
  }
  return res
}

// 污染溯源
const traceSource = () => {
  // Bus.emit('closeModal')
  const data1 = {
    ...props.data,
  }
  Bus.emit('mapClick', {
    data: { ...data1 },
    modalType: '污染溯源',
  })
}
const changeTime = () => {
  getTrend()
}
onMounted(() => {
  if (props.data.waterTrendData && props.data.waterTrendData.length) {
    select(props.data.waterTrendData[0])
  } else {
    getTrend()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.data.dmmc), 1),
      _createElementVNode("div", {
        class: "btn",
        onClick: traceSource
      }, "污染溯源")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.data.zyCbWry), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.quality, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "data-box"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["value", getFontSize(item.value)])
                  }, _toDisplayString(item.value || item.value === 0 ? item.value : '-'), 3),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.waterTrendData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["echart-btn", { active: _unref(selectFactor).code === item.code }]),
                onClick: ($event: any) => (select(item))
              }, _toDisplayString(item.name), 11, _hoisted_17))
            }), 128))
          ]),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(AutoMonitor, {
            ref_key: "autoMonitor",
            ref: autoMonitor
          }, null, 512)
        ])
      ])
    ])
  ]))
}
}

})